var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapClasses},[_c('input',{attrs:{"type":"text","placeholder":_vm.placeholder},on:{"input":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }